<template>
  <section>
    <!-- <h2>Unleash Your Inner Photographer at Pics N Cart: Snap, Win, Shop</h2> -->
    <!-- <div class="services-container d-flex justify-space-between align-center">
      <div class="service" v-for="(item, index) in services" :key="index">
        <v-card class="mx-auto" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="text-h6 mb-1">
                {{ item.title }}
              </v-list-item-title>
              <v-list-item-subtitle>{{
                item.description
              }}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar tile size="80" color="">
              <v-icon size="40" color="primary">{{ item.icon }}</v-icon>
            </v-list-item-avatar>
          </v-list-item>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined color="primary" @click="goto(item.link)">
              Explore
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div> -->

    <div class="pnc-services-container">
      <div class="pnc-service" v-for="(item, index) in services" :key="index">
        <v-icon size="100" color="#000" class="service-icon">{{ item.icon }}</v-icon>
        <h3>{{ item.title }}</h3>
        <p>{{ item.description }}</p>
        <v-btn outlined color="primary" @click="goto(item.link)">
          Explore
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      services: [
        {
          title: "Shop",
          description:
            "Shop from our various range of Camera, Lenses and more.",
          link: "/shop",
          icon: "mdi-cart",
        },
        {
          title: "Contests",
          description:
            "Participate from a variety of different category contests.",
          link: "/contests",
          icon: "mdi-image-multiple",
        },
        {
          title: "Photographers",
          description: "Best Photographers for the Categories",
          link: "/photographers",
          icon: "mdi-camera-plus",
        },
      ],
    };
  },
  methods: {
    goto(link) {
      this.$router.push(link);
    },
  },
};
</script>

<style scoped>
section {
  margin: 3rem;
}

h2 {
  text-align: center;
  color: #151740;
}
.services-container {
  width: 70%;
  margin: 2rem auto 0 auto;
}

.service {
  width: 280px;
}

.pnc-services-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 2rem;
}

.pnc-service {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 30%;
  text-align: center;
}

.pnc-service h3 {
  margin-top: 1rem;
  color: #151740;
}

.pnc-service p {
  color: #4f4f4f;
  width: 80%;
  margin-top: 1rem;
}

.pnc-service .service-icon {
  /* border: 1px solid #151740; */
  /* border-radius: 50%; */
  /* padding: 1rem; */
}

@media screen and (max-width: 600px) {
  .pnc-services-container {
    flex-direction: column;
  }

  .pnc-service {
    width: 80%;
  }

  .pnc-service:not(:first-child) {
    margin-top: 2rem;
  }
}
</style>